import RentalConditions from '../feesAndPolicies/sections/rentalConditions/RentalConditions';

const PropertySettingsRentalConditionsTab = () => {
  return <RentalConditions />;
};

export default PropertySettingsRentalConditionsTab;
